(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-play-2"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });
        // Function to switch tabs
        function switchTab(tabId) {
            document.querySelectorAll('.tab').forEach(tab => {
                tab.classList.remove('active');
            });
            document.getElementById(tabId).classList.add('active');
             // Update tab buttons
            document.querySelectorAll('.tab-button').forEach(button => {
                button.classList.remove('active');
            });
            document.querySelector(`.tab-button[data-tab="${tabId}"]`).classList.add('active');

            // Store the selected tab in localStorage
            localStorage.setItem('selectedTab', tabId);

            //Update Active Color
            var r = document.querySelector(':root');
            if (localStorage.getItem('selectedTab') === 'tabSP') {
              r.style.setProperty('--color-active', '#78d22b');
            } else {
              r.style.setProperty('--color-active', '#f9df18');
            }
        }
                // Expose switchTab to the global scope
                window.switchTab = switchTab;

        // Event listeners for tab buttons
        document.querySelectorAll('.tab-button').forEach(button => {
            button.addEventListener('click', () => {
                switchTab(button.getAttribute('data-tab'));
            });
        });

        // Restore selected tab on page load
        document.addEventListener('DOMContentLoaded', () => {
            const selectedTab = localStorage.getItem('selectedTab') || 'tabSP';
            switchTab(selectedTab);
        });
  /*
  document.addEventListener("DOMContentLoaded", function() {
			var shopToys = document.querySelector('.shop-toys');
			var shopSports = document.querySelector('.shop-sports');
			var shopToysM = document.querySelector('.shop-toysM');
			var shopSportsM = document.querySelector('.shop-sportsM');
      var shopToysM2 = document.querySelector('.shop-toysM2');
			var shopSportsM2 = document.querySelector('.shop-sportsM2');
			var navToys = document.querySelector('.nav-toys');
			var navSports = document.querySelector('.nav-sports');
			var secondaryNav = document.querySelector('.secondary-nav');
			var r = document.querySelector(':root');

      
			shopToys.addEventListener('click', function() {
				shopSports.classList.remove('active2');
				shopToys.classList.add('active2');
        shopSportsM.classList.remove('active2');
				shopToysM.classList.add('active2');
        shopSportsM2.classList.remove('active2');
				shopToysM2.classList.add('active2');
				navSports.classList.remove('active');
				navToys.classList.add('active');
				r.style.setProperty('--color-active', '#f9df18');
			});
			shopSports.addEventListener('click', function() {
				shopToys.classList.remove('active2');
				shopSports.classList.add('active2');
        shopToysM.classList.remove('active2');
				shopSportsM.classList.add('active2');
        shopToysM2.classList.remove('active2');
				shopSportsM2.classList.add('active2');
				navToys.classList.remove('active');
				navSports.classList.add('active');
				r.style.setProperty('--color-active', '#78d22b');
			});
      shopToysM.addEventListener('click', function() {
				shopSports.classList.remove('active2');
				shopToys.classList.add('active2');
        shopSportsM.classList.remove('active2');
				shopToysM.classList.add('active2');
        shopSportsM2.classList.remove('active2');
				shopToysM2.classList.add('active2');
				navSports.classList.remove('active');
				navToys.classList.add('active');
				r.style.setProperty('--color-active', '#f9df18');
			});
			shopSportsM.addEventListener('click', function() {
				shopToys.classList.remove('active2');
				shopSports.classList.add('active2');
        shopToysM.classList.remove('active2');
				shopSportsM.classList.add('active2');
        shopToysM2.classList.remove('active2');
				shopSportsM2.classList.add('active2');
				navToys.classList.remove('active');
				navSports.classList.add('active');
				r.style.setProperty('--color-active', '#78d22b');
			});
      shopToysM2.addEventListener('click', function() {
				shopSports.classList.remove('active2');
				shopToys.classList.add('active2');
        shopSportsM.classList.remove('active2');
				shopToysM.classList.add('active2');
        shopSportsM2.classList.remove('active2');
				shopToysM2.classList.add('active2');
				navSports.classList.remove('active');
				navToys.classList.add('active');
				r.style.setProperty('--color-active', '#f9df18');
			});
			shopSportsM2.addEventListener('click', function() {
				shopToys.classList.remove('active2');
				shopSports.classList.add('active2');
        shopToysM.classList.remove('active2');
				shopSportsM.classList.add('active2');
        shopToysM2.classList.remove('active2');
				shopSportsM2.classList.add('active2');
				navToys.classList.remove('active');
				navSports.classList.add('active');
				r.style.setProperty('--color-active', '#78d22b');
			});
			}); */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-play"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  document.addEventListener("DOMContentLoaded", function() {
			var shopToys = document.querySelector('.shop-toys');
			var shopSports = document.querySelector('.shop-sports');
			var shopToysM = document.querySelector('.shop-toysM');
			var shopSportsM = document.querySelector('.shop-sportsM');
      var shopToysM2 = document.querySelector('.shop-toysM2');
			var shopSportsM2 = document.querySelector('.shop-sportsM2');
			var navToys = document.querySelector('.nav-toys');
			var navSports = document.querySelector('.nav-sports');
			var secondaryNav = document.querySelector('.secondary-nav');
			var r = document.querySelector(':root');

      
			shopToys.addEventListener('click', function() {
				shopSports.classList.remove('active2');
				shopToys.classList.add('active2');
        shopSportsM.classList.remove('active2');
				shopToysM.classList.add('active2');
        shopSportsM2.classList.remove('active2');
				shopToysM2.classList.add('active2');
				navSports.classList.remove('active');
				navToys.classList.add('active');
				r.style.setProperty('--color-active', '#f9df18');
			});
			shopSports.addEventListener('click', function() {
				shopToys.classList.remove('active2');
				shopSports.classList.add('active2');
        shopToysM.classList.remove('active2');
				shopSportsM.classList.add('active2');
        shopToysM2.classList.remove('active2');
				shopSportsM2.classList.add('active2');
				navToys.classList.remove('active');
				navSports.classList.add('active');
				r.style.setProperty('--color-active', '#78d22b');
			});
      shopToysM.addEventListener('click', function() {
				shopSports.classList.remove('active2');
				shopToys.classList.add('active2');
        shopSportsM.classList.remove('active2');
				shopToysM.classList.add('active2');
        shopSportsM2.classList.remove('active2');
				shopToysM2.classList.add('active2');
				navSports.classList.remove('active');
				navToys.classList.add('active');
				r.style.setProperty('--color-active', '#f9df18');
			});
			shopSportsM.addEventListener('click', function() {
				shopToys.classList.remove('active2');
				shopSports.classList.add('active2');
        shopToysM.classList.remove('active2');
				shopSportsM.classList.add('active2');
        shopToysM2.classList.remove('active2');
				shopSportsM2.classList.add('active2');
				navToys.classList.remove('active');
				navSports.classList.add('active');
				r.style.setProperty('--color-active', '#78d22b');
			});
      shopToysM2.addEventListener('click', function() {
				shopSports.classList.remove('active2');
				shopToys.classList.add('active2');
        shopSportsM.classList.remove('active2');
				shopToysM.classList.add('active2');
        shopSportsM2.classList.remove('active2');
				shopToysM2.classList.add('active2');
				navSports.classList.remove('active');
				navToys.classList.add('active');
				r.style.setProperty('--color-active', '#f9df18');
			});
			shopSportsM2.addEventListener('click', function() {
				shopToys.classList.remove('active2');
				shopSports.classList.add('active2');
        shopToysM.classList.remove('active2');
				shopSportsM.classList.add('active2');
        shopToysM2.classList.remove('active2');
				shopSportsM2.classList.add('active2');
				navToys.classList.remove('active');
				navSports.classList.add('active');
				r.style.setProperty('--color-active', '#78d22b');
			});
			});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-nav"] && !window.DesignMode) return;
  try {
    
switchTab('tabTO')

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-navS"] && !window.DesignMode) return;
  try {
    
switchTab('tabSP')

  } catch(e) { console.error(e); }
})();
})();
